import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import { Icon, regularIcons } from '../../../generic';
import Tooltip from '../../../generic/Tooltip';

import { formatDate } from './utils';

import sharedStyles from '../IssueDetails.module.less';
import styles from './IssueDetailsStatus.module.less';

type UserEmailProps = { userEmail: string };

/**
 * Add a tooltip on user email.
 */
const UserEmail: VoidFunctionComponent<UserEmailProps> = ({ userEmail }) => (
  <Tooltip id="ignoredBy" tooltip={<div>{userEmail}</div>}>
    <span className={`bold ${styles.userEmail}`}>{userEmail}</span>
  </Tooltip>
);

/**
 * Display the issue details status in the project scope.
 */
const ProjectScopeIssueDetailsStatus: VoidFunctionComponent = () => {
  const isActive = useSelector(IssuesV2Store.selectors.getIsIssueActive);
  const isIgnored = useSelector(IssuesV2Store.selectors.getIsIssueIgnored);
  const isTicketed = useSelector(IssuesV2Store.selectors.getIsIssueTicketed);
  const ignoredBy = useSelector(IssuesV2Store.selectors.getIssueIgnoredBy);
  const ignoredAt = useSelector(IssuesV2Store.selectors.getIssueIgnoredAt);
  const createdAt = useSelector(IssuesV2Store.selectors.getIssueCreatedAt);
  const ignoredByText = ignoredBy ? (
    <span>
      by <UserEmail userEmail={ignoredBy} />{' '}
    </span>
  ) : (
    ''
  );

  return (
    <div className={styles.projectIssueDetailsStatus}>
      {isActive && (
        <span>
          <span className={`${sharedStyles.icon} ${sharedStyles.activeIcon}`}>
            <Icon icon={regularIcons.exclamationCircleRegular} />
          </span>
          <span className="bold">Active</span> found {formatDate(createdAt)}
        </span>
      )}
      {isIgnored && (
        <span>
          <span className={`${sharedStyles.icon} ${sharedStyles.ignoredIcon}`}>
            <Icon icon={regularIcons.eyeSlashRegular} />
          </span>
          <span className="bold">Ignored</span> {ignoredByText}
          {formatDate(ignoredAt)}
        </span>
      )}
      {isTicketed && (
        <span>
          <span className={`${sharedStyles.icon} ${sharedStyles.ticketedIcon}`}>
            <Icon icon={regularIcons.ticket} />
          </span>
          <span className="bold">Ticketed</span>
        </span>
      )}
    </div>
  );
};

export default ProjectScopeIssueDetailsStatus;
